// Amharic translations
export const am: Record<string, string> = {
  'menu.dashboard': 'ዳሽቦርድ',
  'menu.customers': 'ደንበኞች',
  'menu.products': 'ምርቶች',
  'menu.users': 'ተጠቃሚዎች',
  'menu.settings': 'ቅንብሮች',
  'menu.logout': 'ውጣ',
  'dashboard.title': 'ዳሽቦርድ',
  'dashboard.newOrder': 'አዲስ ትዕዛዝ',
  'order.title': 'አዲስ ትዕዛዝ',
  'order.customer': 'ደንበኛ',
  'order.products': 'ምርቶች',
  'order.total': 'ድምር',
  'order.payment': 'ክፍያ',
  'users.title': 'ተጠቃሚዎች',
  'users.name': 'ስም',
  'users.email': 'ኢሜይል',
  'common.yes': 'አዎ',
  'common.no': 'አይ',
  'common.cancel': 'ሰርዝ',
  'common.save': 'አስቀምጥ',
  'common.search': 'ፈልግ',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'ግባ',
  'login.welcome': 'እንኳን ደህና መጡ, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.createAccount': 'መለያ ፍጠር',
  'signup.email': 'ኢሜይል',
  'signup.phone': 'ስልክ',
  'menu.reportsAndAccounting': 'ሪፖርቶች እና ሂሳብ',
  'menu.systemAndCommunication': 'ሲስተም እና ግንኙነት',
};